export default __webpack_public_path__ + "static/media/contact-us-hero-background.df475f74.png";